import './bootstrap';
import { q, clickAndEnterListener, getElementDistanceFromTop } from './utilities';
import Swiper from 'swiper';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

if (q('#teaser-page')) {
  let imagesLoaded = 0;

  q('.swiper img').forEach((img) => {
    img.addEventListener('load', () => {
      imagesLoaded++;
      if (imagesLoaded >= q('.swiper img').length) {
        q('.swiper').style.opacity = 1;
      }
    });
  });

  q('video').forEach((video) =>{
    video.addEventListener('loadeddata', () => {
      q('.video-placeholder').classList.add('d-none');
      video.classList.remove('loading');
    });
  });

  new Swiper('.swiper', {
    modules: [Autoplay],
    loop: true,
    slidesPerView: 3,
    centeredSlides: true,
    autoplay: {
      delay: 2000,
    },
    spaceBetween: 30,
    breakpoints: {
      768: {
        slidesPerView: 5,
      },
    },
  });
}

if (q('#offer-page')) {
  setTimeout(() => {
    $('#offerModal').modal('show');
  }, 60000);
  clickAndEnterListener(q('#offerModal .btn-1'), () => {
    q('#register').scrollIntoView();
    $('#offerModal').modal('hide');
  });
}
